export default __webpack_public_path__ + "static/media/discord.eadb1f0b.svg";